/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmergencyMessageOnAzure,
  EmergencyMessageSelfCreate,
  EmergencyMessageSelfDelete,
  EmergencyMessageSelfDeleteV1,
} from '../models/index';
import {
    EmergencyMessageOnAzureFromJSON,
    EmergencyMessageOnAzureToJSON,
    EmergencyMessageSelfCreateFromJSON,
    EmergencyMessageSelfCreateToJSON,
    EmergencyMessageSelfDeleteFromJSON,
    EmergencyMessageSelfDeleteToJSON,
    EmergencyMessageSelfDeleteV1FromJSON,
    EmergencyMessageSelfDeleteV1ToJSON,
} from '../models/index';

export interface ApiEmergencyMessageAddPostRequest {
    emergencyMessageSelfCreate?: EmergencyMessageSelfCreate;
}

export interface ApiEmergencyMessageSoftDeletePutRequest {
    emergencyMessageSelfDelete?: EmergencyMessageSelfDelete;
}

export interface ApiEmergencyMessageSoftDeleteV1PutRequest {
    emergencyMessageSelfDeleteV1?: EmergencyMessageSelfDeleteV1;
}

/**
 * 
 */
export class EmergencyMessageApi extends runtime.BaseAPI {

    /**
     */
    async apiEmergencyMessageAddPostRaw(requestParameters: ApiEmergencyMessageAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyMessageOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyMessage/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmergencyMessageSelfCreateToJSON(requestParameters['emergencyMessageSelfCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyMessageOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyMessageAddPost(requestParameters: ApiEmergencyMessageAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyMessageOnAzure> {
        const response = await this.apiEmergencyMessageAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyMessageSoftDeletePutRaw(requestParameters: ApiEmergencyMessageSoftDeletePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyMessage/SoftDelete`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmergencyMessageSelfDeleteToJSON(requestParameters['emergencyMessageSelfDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiEmergencyMessageSoftDeletePut(requestParameters: ApiEmergencyMessageSoftDeletePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiEmergencyMessageSoftDeletePutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiEmergencyMessageSoftDeleteV1PutRaw(requestParameters: ApiEmergencyMessageSoftDeleteV1PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyMessageOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/EmergencyMessage/SoftDelete_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmergencyMessageSelfDeleteV1ToJSON(requestParameters['emergencyMessageSelfDeleteV1']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyMessageOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyMessageSoftDeleteV1Put(requestParameters: ApiEmergencyMessageSoftDeleteV1PutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyMessageOnAzure> {
        const response = await this.apiEmergencyMessageSoftDeleteV1PutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
